<template>
    <div>

        <div class="report-area">
            <div class="report-area-title-tag" id="report-alerts-calendar">{{ $t('report.ui.alert_calendar') }}</div>
            <div class="report-area-card">
                <div class="print-chart-scroll">
                    <div class="print-chart-area-full" v-if="Object.keys( alertData ).length > 0">

                        <div>
                            <div class="chart-summary">
            
                                <!-- 按鈕列表 -->
                                <div class="btn-list area-overflow-y scroll-style">
                                    
                                    <div v-for="(data_alert, key_alert, idx_a) in alertData" :key="idx_a"
                                        :class="'report-stress' + ( actived_alert == key_alert ? ' btn-active' : '' )"
                                        @click="switchAlert(key_alert)">
                                        <div type="button"
                                            :class="'btn-stress btn-stress_' + key_alert"
                                            v-html="getStressBtnText(key_alert)">
                                        </div>
                                        <div class="report-stress-count" v-if="data_alert.count">{{ data_alert.count }}</div>
                                    </div>

                                </div>
                                
                                <!-- 工作建議表 -->
                                <div class="work-list area-overflow scroll-style" v-if="actived_alert">
                                    <div v-if="actived_alert_data.count">
                                        <div class="info-title"><i class="fa fa-bullhorn"></i>{{ $t('menu.data_count') }}</div>
                                        <div class="info-body">{{ $t('menu.total') }}：{{ actived_alert_data.count }}</div>

                                        <div class="info-body" v-for="(data_device, key_device, idx_d) in actived_alert_data.by_device" :key="idx_d">
                                            <div class="block-text">{{ idx_d + 1 }}.</div>
                                            <div v-if="deviceInfo[ key_device ]" class="info-text">
                                                {{ $t('n.' + deviceInfo[ key_device ].type) }}
                                                <i :class="$tools.style.classIcon(deviceInfo[ key_device ].type, 'block-text')"></i>{{ key_device }}
                                                <br>
                                                <div class="info-text-sub">{{ $t('n.device') }} {{ $t('menu.name') }}： {{ deviceInfo[ key_device ].nickname }}</div>
                                                <br>
                                                <div class="info-text-sub">{{ $t('menu.data_count') }} : {{ data_device }}</div>
                                            </div>
                                            <div v-else class="info-text">
                                                {{ key_device }} {{ $t('menu.data_count') }} : {{ data_device }}
                                            </div>
                                        </div>

                                        <hr>

                                        <!-- 防治建議 -->
                                        <div>
                                            <div class="info-title"><i class="fa fa-ambulance"></i>{{ $t('menu.suggested_preventions') }}</div>
                                            <div class="stress-prevention-area" v-if="actived_alert_data.works && actived_alert_data.works.length > 0">

                                                <div v-for="(work, idx_w) in actived_alert_data.works" :key="idx_w">

                                                    <!-- 先隱藏不顯示圖片 -->
                                                    
                                                    <!-- <b-row v-if="work.url" class="stress-prevention-work">
                                                        <b-col md="8" sm="7">
                                                            <div class="stress-prevention-idx"># {{ idx_w + 1 }}.</div>
                                                            <div class="stress-prevention-text">{{ work.management }}</div>
                                                        </b-col>
                                                        <b-col md="4" sm="5" cols="8">
                                                            <b-img class="clickable-img" thumbnail fluid
                                                                    :src="work.url" :alt="work.management"
                                                                    @click="$tools.ui.openNewPage(work.url)"></b-img>
                                                        </b-col>
                                                    </b-row> -->
                                                    <!-- <div v-else class="stress-prevention-work"> -->
                                                    <div class="stress-prevention-work">
                                                            <div class="stress-prevention-idx"># {{ idx_w + 1 }}.</div>
                                                            <div class="stress-prevention-text">{{ work[ language ] }}</div>
                                                    </div>
                                                    <hr class="stress-prevention-work-dividing-line">
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div v-else>
                                        {{ $t('menu.no_data') }}
                                    </div>
                                    
                                </div>

                            </div>

                            <!-- 日曆熱力圖圖表 -->
                            <div class="chart-draw" v-if="actived_alert">
                                <CalendarChartAlerts    :chartID="'alerts-heatmap-chart-'"
                                                        :preSaveName="cropperiodData.project_name + ' ' + cropperiodData.name"
                                                        :stressCode="actived_alert"
                                                        :data="actived_alert_data.data"
                                                        :time="timeData.day"
                                                        :deviceInfo="deviceInfo"
                                                        :displayColor="'red'"
                                                        :filterTextMin="$t('menu.alert_filter')"
                                                        :filterTextMax="''"
                                ></CalendarChartAlerts>
                            </div>



                        </div>

                    </div>
                    <div v-else>
                        <NoData :showInfo="$t('menu.no_alert_data')" :showIcon="true"></NoData>
                    </div>
                    
                </div>

            </div>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import NoData from '@/views/components/NoData'
import CalendarChartAlerts from '@/views/echarts/CalendarChart_Alerts'

export default {
    props: {
        alertData: {
            type: Object,
            default: function () { return {} }
        },
        cropperiodData: {
            type: Object,
            default: function () { return {} }
        },
        deviceInfo: {
            type: Object,
            default: function () { return {} }
        },
        timeData: {
            type: Object,
            default: function () { return {} }
        },
    },
    components: {
        NoData,
        CalendarChartAlerts,
    },
    data () {
        return {
            actived_alert: undefined,
            actived_alert_data: {},
        }
    },
    mounted ()
    {
        this.arrangeAlertData( this.alertData )
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
        }),

    },
    watch: {

        alertData (val, oldVal)
        {
            this.arrangeAlertData(val)
        },

    },
    methods: {

        switchAlert (alert_code)
        {
            this.actived_alert = alert_code
            this.actived_alert_data = this.alertData[ alert_code ]
        },

        getStressBtnText (alert_code)
        {
            return `<i class="${ this.$tools.style.classStressIcon( alert_code, 'block-text' ) }"></i>${ this.$t('stress.' + alert_code) }`;
        },

        arrangeAlertData (data)
        {
            if (data)
            {
                this.actived_alert = undefined
                for ( let _alertCode in data )
                {
                    // 預設先選第一個預警來看
                    if ( this.actived_alert == undefined ) this.switchAlert( _alertCode )

                    data[ _alertCode ].count = 0        // 先初始化所有預警總數為 0
                    data[ _alertCode ].by_device = {}   // 先初始化感測器預警
                    let _alertData = data[ _alertCode ].data

                    if ( _alertData )
                    {
                        let _count = 0

                        _alertData.forEach( _data_a_day => {
                            if ( _data_a_day )
                            {
                                _count += _data_a_day.length

                                // 計算每隻感測器有幾筆資料
                                _data_a_day.forEach( __alert => {
                                    if ( data[ _alertCode ].by_device[ __alert.hashid ] == undefined ) data[ _alertCode ].by_device[ __alert.hashid ] = 1
                                    else data[ _alertCode ].by_device[ __alert.hashid ] += 1
                                })
                            }
                        })
                        // console.log( _count )
                        data[ _alertCode ].count = _count
                    }
                }
            }
        },

    }
}
</script>

<style lang="scss" scoped>

$summary-max-height: 330px;

.chart-summary
{
    cursor: default;
    display: inline-block;
    vertical-align: top;
    padding-top: 5px;

    .btn-list
    {
        display: inline-block;
        vertical-align: top;
        min-width: 230px;
        max-height: $summary-max-height;
        margin-right: 10px;
        padding-right: 5px;
        
        .report-stress
        {
            display: block;
            cursor: pointer;
            border: none;

            &:hover
            {
                transform: translate( 5px, 0px);
                background-color: #8ce9db;
                border-color: #8ce9db;
                color: #000000;
            }
        }
        .btn-active
        {
            background-color: #66c6b4;
            border-color: #74d1c0;
            color: #000000;
        }
    }
    .work-list
    {
        cursor: default !important;
        display: inline-block;
        width: 350px;
        max-height: $summary-max-height;

        background-color: rgba(116, 209, 158, 0.3);
        border-radius: 8px;
        padding: 5px 10px;
    }

}

.chart-draw
{
    display: inline-block;
}

.info-title
{
    font-size: 1.2rem;
    margin: 5px 5px 5px 0px;
}
.info-body
{
    margin-left: 20px;
}
.info-text
{
    display: inline;
    margin-right: 30px;
}
.info-text-sub
{
    display: inline-block;
    margin-left: 22px;
}
.stress-prevention-area
{
    cursor: default;
    margin-bottom: 10px;
    padding: 2px 10px 2px 20px;
    // font-size: 0.9rem;
    color: #475d5d;
    max-height: 300px;
    overflow-y: auto;

    .stress-prevention-work
    {
        margin-bottom: 5px;
    }
    .stress-prevention-work-dividing-line
    {
        margin: 5px 0px;
    }
}

</style>